import { assign } from "lodash/fp";

export const assignRight = _.curry((sources, obj) => assign(obj, sources));
